import React from "react";
import { Outlet, useParams } from "react-router-dom";
import { useCrumb } from "@poseidon/ui/app/crumbs/CrumbContext";
import { RouterTabs } from "@poseidon/ui/components/RouterTabs";
import { AgreementProvider, useAgreementContext } from "./AgreementContext";
import { PendingAgreementPage } from "./pages/PendingAgreementPage";
import { SailorVulnerabilityFlags } from "../Sailors/components/SailorVulnerabilityFlags";

const tabs = [
  {
    to: "",
    label: "Summary",
  },
  {
    to: `/transactions`,
    label: "Transactions",
  },
  {
    to: `/payments`,
    label: "Payments",
  },
  {
    to: `/settlements`,
    label: "Settlements",
  },
  {
    to: `/arrears`,
    label: "Arrears Management",
  },
];
const AgreementTabs = () => {
  const agreement = useAgreementContext();
  if (!agreement || agreement.status === "pending") {
    return <PendingAgreementPage />;
  }
  const baseHref = `/agreements/${agreement.id}`;
  return (
    <>
      <SailorVulnerabilityFlags sailorRefs={agreement.sailors} />
      <RouterTabs tabs={tabs} baseHref={baseHref} />
    </>
  );
};
const AgreementsOutlet = () => {
  useCrumb("/agreements/", {
    to: `/agreements`,
    text: "Agreements",
  });
  const { agreementId } = useParams();
  if (agreementId) {
    return (
      <AgreementProvider agreementId={agreementId}>
        <AgreementTabs />
      </AgreementProvider>
    );
  } else {
    return <Outlet />;
  }
};

export default AgreementsOutlet;
